export enum BusinessNotifications {
  DeliveryClosing = 'deliveryclosing',
  PickupClosing = 'pickupclosing',
  RestaurantClosed = 'restaurantclosed',
  OnlyFutureOrders = 'onlyFutureOrders',
  OlOunavailable = 'olounavailable',
  CantAcceptOrders = 'cantAcceptOrders',
  NotPremium = 'notpremium',
  NoPaymentMethods = 'nopaymentmethods',
  NoPhysicalLocation = 'nophysicallocation',
}
